module.exports = __webpack_public_path__ + "img/dabing.bb6b9168.png";